










































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import RestClient, { RestError, ServerError } from "../RestClient";
import DemoServer from "../shared/DemoServer";
import Utils from "../shared/Utils";
import DateFormatter from "../shared/DateFormatter";

import Loading from "../components/general/Loading.vue";
import TextView from "../components/controls/TextView.vue";
import ApprovalList from "../components/controls/ApprovalList.vue";

import { WorkshopBookingStatus } from "../shared/WorkshopBookingStatus";
import { WorkshopInfoJson } from "../shared/WorkshopJson";
import WorkshopBookingJson from "../shared/WorkshopBookingJson";

import CustomerJson, { defaultCustomerJson } from "../shared/CustomerJson";
import SepaMandateJson from "../shared/SepaMandateJson";

import { Gender } from "../shared/Gender";
import { validateWorkshopBookingJsonBookingForm } from "../shared/WorkshopBookingJson";
import { ValidationResult, Validation, ValidationErrorType } from "../shared/Validation";

import CustomContent from "../components/custom/WorkshopsRegistration";

export default Vue.extend({
  name: "kurse",
  components: {
    Loading,
    TextView,
    ApprovalList,
  },
  data() {
    return {
      RestClient: RestClient,
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Gender: Gender,
      CustomContent: CustomContent,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      urlParams: null as URLSearchParams | null,
      embeddedStyle: false as boolean,
      supportsDatePicker: false,
      WorkshopBookingStatus: WorkshopBookingStatus,
      workshopInfos: null as WorkshopInfoJson[] | null,
      selectedWorkshopId: null as number | null,
      selectedPriceIndex: null as number | null,
      bookingDetails: null as WorkshopBookingJson | null,
      cachedBirthDate: "" as string,
      validation: null as ValidationResult<WorkshopBookingJson> | null,
      toValidate: {} as any,
      submitValidation: false,
      differentAddress: false,
      showValidationWarnung: false as boolean,
      submitLoading: false as boolean,
      submitSuccess: false as boolean,
      inquiryResult: "" as string,
    };
  },
  created() {
    this.getUrlParams();
    this.initBooking();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    getUrlParams() {
      this.urlParams = new URL(location.href).searchParams;
    },

    async initBooking() {
      await this.loadWorkshopInfos();
      await this.loadWorkshopBookingDetails();

      if (this.urlParams != null) {
        this.embeddedStyle = Utils.getUrlParamBool(this.urlParams.get("embedded"));

        let workshopId = Utils.getUrlParamNum(this.urlParams.get("workshopId"));
        if (workshopId) {
          this.selectedWorkshopId = workshopId;
        }
      }
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>document.querySelector("#testDatePicker input");

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadWorkshopInfos() {
      try {
        this.workshopInfos = await this.RestClient.getWorkshopBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadWorkshopBookingDetails() {
      this.bookingDetails = {
        ID: null,
        customer: this.getDefaultCustomer(),
        remarks: "",
        state: WorkshopBookingStatus.requested,
        selectedPriceTitle: "",
        selectedPriceRemarks: "",
        priceDeposit: 0,
        priceNonDeposit: 0,
        cancellationFee: 0,
        cancellationRemarks: "",
        bookingDateTime: new Date().toISOString(),
        sepaMandate: this.getDefaultSepaMandate(),
        invoiceInfos: null,
      };
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: "",
        accountHolderLastName: "",
        addressStreet: "",
        addressZip: "",
        addressCity: "",
        addressCountry: "Deutschland",
        IBAN: "",
        BIC: "",
      };
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.bookingDetails != null) {
        this.validation = validateWorkshopBookingJsonBookingForm(this.bookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async submitForm() {
      if (this.selectedWorkshopId != null) {
        if (this.bookingDetails != null) {
          this.submitLoading = true;

          //set prices
          this.setWorkshopPrice();

          //set different address
          if (!this.differentAddress) {
            this.setDifferentAddress();
          }

          //add dateTime to sepa mandate
          if (this.bookingDetails.sepaMandate != null) {
            let now = new Date().toISOString();
            this.bookingDetails.sepaMandate.dateTime = now;
          }

          //final validation
          this.validation = validateWorkshopBookingJsonBookingForm(this.bookingDetails);
          this.submitValidation = true;

          //start submit if aprovals and validation is correct
          if (
            (this.$refs.approvalRequired as any).validate() &&
            this.validation != null &&
            this.validation.isValid == true
          ) {
            try {
              this.inquiryResult = await this.RestClient.requestWorkshopBooking(
                this.selectedWorkshopId,
                this.bookingDetails
              );
              this.submitSuccess = true;
              this.submitLoading = false;
            } catch (e) {
              if (e.hasOwnProperty("validationResult")) {
                if (e.validationResult.errors.bookingDateTime == ValidationErrorType.tooManySimultanous) {
                  alert("Der ausgewählte Kurs/Workshop ist leider nicht mehr buchbar. Bitte laden Sie die Seite neu.");
                }
              } else {
                alert(e.message);
              }
              this.submitLoading = false;
            }
          } else {
            this.showValidationWarnung = true;
            this.submitLoading = false;
          }
        }
      } else {
        alert("Es wurde kein Kurs/Workshop ausgewählt.");
      }
    },

    /* setPrices() {
         if (this.bookingDetails != null && this.selectedWorkshopInfos !== undefined) {
            this.bookingDetails.priceDeposit = this.selectedWorkshopInfos.participantPriceDeposit
            this.bookingDetails.priceNonDeposit = this.selectedWorkshopInfos.participantPriceNonDeposit
            this.bookingDetails.cancellationFee = this.selectedWorkshopInfos.cancellationFee
         }
      }, */

    setWorkshopPrice() {
      if (this.bookingDetails != null && this.selectedWorkshopInfos !== undefined && this.selectedPriceIndex !== null) {
        this.bookingDetails.priceDeposit = this.selectedWorkshopInfos.prices[this.selectedPriceIndex].priceDeposit;
        this.bookingDetails.priceNonDeposit =
          this.selectedWorkshopInfos.prices[this.selectedPriceIndex].priceNonDeposit;
        this.bookingDetails.cancellationFee =
          this.selectedWorkshopInfos.prices[this.selectedPriceIndex].cancellationFee;
        this.bookingDetails.cancellationRemarks =
          this.selectedWorkshopInfos.prices[this.selectedPriceIndex].cancellationRemarks;
        this.bookingDetails.selectedPriceTitle = this.selectedWorkshopInfos.prices[this.selectedPriceIndex].title;
        this.bookingDetails.selectedPriceRemarks = this.selectedWorkshopInfos.prices[this.selectedPriceIndex].remarks;
      }
    },

    setBirthDate() {
      if (this.bookingDetails != null && this.bookingDetails.customer != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedBirthDate;
        } else {
          if (this.cachedBirthDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedBirthDate);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.bookingDetails.customer.childBirthDate = birthDate;
      }
    },

    setDifferentAddress() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.customer != null && this.bookingDetails.sepaMandate != null) {
          this.bookingDetails.sepaMandate.accountHolderFirstName = this.bookingDetails.customer.guardianFirstName;
          this.bookingDetails.sepaMandate.accountHolderLastName = this.bookingDetails.customer.guardianLastName;

          this.bookingDetails.sepaMandate.addressStreet = this.bookingDetails.customer.addressStreet;
          this.bookingDetails.sepaMandate.addressZip = this.bookingDetails.customer.addressZip;
          this.bookingDetails.sepaMandate.addressCity = this.bookingDetails.customer.addressCity;
          this.bookingDetails.sepaMandate.addressCountry = this.bookingDetails.customer.addressCountry;
        }
      }
    },

    workshopsSlotState(workshop: WorkshopInfoJson) {
      if (workshop.registrationSlotsFree <= 0) {
        if (workshop.waitingListSlotsFree <= 0) {
          if (workshop.waitingListMaximumCount > 0) {
            return "noFreeWaitingSlot";
          } else {
            return "noWaitingList";
          }
        } else {
          return "waitingList";
        }
      } else {
        return "freeSlot";
      }
    },

    getProgramSeatsLeftString(workshop: WorkshopInfoJson, state: string) {
      if (state == "freeSlot") {
        let freeSeats = workshop.registrationSlotsFree;

        if (freeSeats > 0 && freeSeats < 5) {
          return `${freeSeats} ${freeSeats == 1 ? "freier Platz" : "freie Plätze"}`;
        } else {
          return "";
        }
      } else if (state == "waitingList") {
        let freeSeats = workshop.waitingListSlotsFree;

        if (freeSeats > 0 && freeSeats < 5) {
          return `${freeSeats} ${freeSeats == 1 ? "freier Platz" : "freie Plätze"}`;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {},

  computed: {
    selectedWorkshopInfos(): WorkshopInfoJson | undefined {
      if (this.workshopInfos != null) {
        this.selectedPriceIndex = 0;
        let selectedWorkshopInfos = this.workshopInfos.find((i: any) => i.ID == this.selectedWorkshopId);

        return selectedWorkshopInfos;
      }
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            return this.bookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            this.bookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
